interface DateRange {
  start: Date;
  end: Date;
}

export enum DateGrouping {
  HOUR = 'hour',
  DAY = 'day',
  MONTH = 'month',
}

export interface DateOption {
  label: string;
  getDateRange: () => DateRange;
  group: DateGrouping;
  listGroup: number;
}
